/* eslint react/prop-types: 0 */
/* eslint import/no-unresolved:0 */
/* global $ */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Progress from 'react-progressbar'; /* upload progress */
import s from './UploadsModalVideoLlamada.css';

class UploadsModalVideoLlamada extends React.Component {
  componentDidMount() {}

  componentWillReceiveProps() {}

  componentWillUnmount() {}

  render() {
    const filesUploaded = this.props.filesUploaded;
    return (
      <div className={s.modalVideoLlamadaUploads} id="modalVideoLlamadaUploads">
        <div style={{ padding: '0' }} className="col-md-12 row">
          <div className="col-md-11">
            <strong>Subiendo Archivos</strong>
          </div>
          <div className="col-md-1">
            <button
              style={{
                backgroundColor: '#fff',
                border: '0',
                cursor: 'pointer',
                textAlign: 'right',
                padding: '0',
              }}
              onClick={() => $('#modalVideoLlamadaUploads').hide(200)}
            >
              x
            </button>
          </div>
        </div>

        <br />
        {Object.keys(filesUploaded).map(key =>
          <div
            className={`${s.uploadedFile} row`}
            key={filesUploaded[key].file.name}
          >
            <i
              className="fa fa-picture-o col-1"
              aria-hidden="true"
              style={{ padding: 0 }}
            />
            {filesUploaded[key].progress < 100 ||
            filesUploaded[key].progress === 'Cancelado'
              ? <div className="col-11">
                  <div className="row">
                    <span
                      className="col-4"
                      style={{
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        padding: '0',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {filesUploaded[key].file.name}
                    </span>
                    <span style={{ paddingRight: '0' }} className="col-2">
                      <i
                        className="fa fa-times "
                        aria-hidden="true"
                        style={{ color: '#e4002b', marginLeft: '5px' }}
                      />
                    </span>
                    {filesUploaded[key].progress === 'Cancelado'
                      ? <div style={{ paddingLeft: '0' }} className="col-6">
                          <strong
                            className={
                              filesUploaded[key].motivo === 'Cancelado'
                                ? 'col-8'
                                : 'col-12'
                            }
                            style={{
                              padding: '0',
                              color: '#e4002b',
                              fontSize: '14px',
                            }}
                          >
                            {filesUploaded[key].motivo}
                          </strong>
                          {filesUploaded[key].motivo === 'Cancelado'
                            ? <span
                                className="col-2"
                                onClick={() => this.props.retryUpload(key)}
                                role="button"
                                tabIndex="-1"
                                style={{ color: '#EB0000' }}
                              >
                                Reintentar
                              </span>
                            : ''}
                        </div>
                      : <div className="col-12 row">
                          <Progress
                            className="col-11"
                            completed={filesUploaded[key].progress}
                            color="#007a6e"
                            style={{ paddingLeft: '0' }}
                          />
                          <span
                            className="col-1"
                            onClick={() => this.props.cancelUpload(key)}
                            role="button"
                            tabIndex="-1"
                            style={{
                              padding: '0px',
                              fontSize: '12px',
                              fontWeight: 'bold',
                              marginTop: '-3px',
                              textAlign: 'right',
                            }}
                          >
                            X
                          </span>
                        </div>}
                  </div>
                </div>
              : <div className="col-11 ">
                  <div className="row">
                    <span
                      className="col-4"
                      style={{
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        padding: '0',
                        whiteSpace: 'nowrap',
                        maxWidth: '90%',
                      }}
                    >
                      {filesUploaded[key].file.name}
                    </span>
                    {filesUploaded[key].progress === 'ok'
                      ? <span className="col-6">
                          <i
                            className="fa fa-check "
                            aria-hidden="true"
                            style={{ color: '#478a47', marginLeft: '5px' }}
                          />
                        </span>
                      : ''}
                    {filesUploaded[key].progress === 'cargando'
                      ? <span className="col-6">
                          <strong
                            style={{
                              padding: '0',
                              color: '#000',
                              fontSize: '14px',
                            }}
                          >
                            Subiendo archivo...
                          </strong>
                        </span>
                      : ''}
                  </div>
                </div>}
          </div>,
        )}
      </div>
    );
  }
}
/*
const mapStateToProps = state => ({
  fileuploadStatus: state.telemedicina.fileuploadStatus,
});
*/
export default withStyles(s)(UploadsModalVideoLlamada);



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ModalVideoLlamada/UploadsModalVideoLlamada/UploadsModalVideoLlamada.js